import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { ExpandMore } from "@mui/icons-material";
import { useWatch } from "react-hook-form";
import { IFormValues } from "../../types";
import DisableFormTextField from "../../_components/DisableFormTextField";

const AdditionalDrivers = () => {
    const { t } = useTranslation('booking');

    const additionalDriver = useWatch<IFormValues, 'additionalDriver'>({
        name: 'additionalDriver'
    });

    return (
        <>
        { additionalDriver?.length > 0 &&
            <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore/>}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                            <Typography variant="h5">
                                {t('label.additionalDriversDetails')}
                            </Typography>
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container>
                            {additionalDriver?.map((ad, i) => (
                                <Grid key={i} container item xs={12} rowSpacing={1} columnSpacing={3}>
                                    <Grid item xs={12} sm={3}>
                                        <DisableFormTextField name={`additionalDriver.${i}.id`} label={'label.id'}/>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <DisableFormTextField name={`additionalDriver.${i}.firstName`}
                                                              label={'label.firstName'}/>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <DisableFormTextField name={`additionalDriver.${i}.lastName`}
                                                              label={'label.lastName'}/>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <DisableFormTextField name={`additionalDriver.${i}.email`}
                                                              label={'label.email'}/>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <DisableFormTextField name={`additionalDriver.${i}.webCheckIn`}
                                                              label={'label.webCheckIn'}/>
                                    </Grid>

                                    {i !== additionalDriver?.length - 1 &&
                                    <Divider orientation={"horizontal"} style={{width: '100%'}}
                                             sx={{mt: 4, mb: 3, marginLeft: '12px'}} textAlign={"center"}/>
                                    }
                                </Grid>
                            ))}
                        </Grid>
                    </AccordionDetails>
                </Accordion>
        }
        </>
    )
};

export default AdditionalDrivers;
